<script setup lang="ts">
// import TransitionCustom from './components/TransitionCustom.vue';
import { ref, onMounted, computed, defineAsyncComponent } from 'vue';
import { RouterView, useRoute, useRouter } from 'vue-router';
const router = useRouter()
const isReady = ref(false)
const route = useRoute();

onMounted(async () => {
  await router.isReady()
  isReady.value = true
})

const isStandalone = computed(() => route.meta.standalone === true);
const PageLayout = defineAsyncComponent(() => import('@/components/layouts/PageLayout.vue'))

</script>

<template>
  <template v-if="isReady">
    <PageLayout v-if="!isStandalone">
      <!-- <router-view v-slot="{ Component, route }">
        <TransitionCustom name="slide-fade">
          <component :is="Component" :key="route.path" />
        </TransitionCustom>
      </router-view> -->
      <RouterView />
    </PageLayout>
    <RouterView v-else />
  </template>
</template>

<style scoped>

</style>
